<template>
    <div>
        <common-training-header :in-header="true" :withUser="false" />

        <a-card type="inner" size="small" style="margin-top: 24px;">
            <a-row style="margin-bottom: 20px;">
                <a-col class="text-right">
                    <download-excel :data="excel" name="training-evaluation-report.xls">
                        <a-button :loading="loading" type="primary">Download <a-icon type="cloud-download" /> </a-button>
                    </download-excel>
                </a-col>
            </a-row>
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="tableData" rowKey="id" :pagination="false" :rowClassName="(r) => r.is_heading ? 'row-heading' : null" bordered>
                    <a-table-column key="title" title="Materi Pelatihan" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <template v-if="record.is_heading"><strong>{{ record.name }}</strong></template>
                            <template v-else>{{ record.name }}</template>
                        </template>
                    </a-table-column>

                    <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                        <div slot-scope="record" v-if="! record.is_heading">
                            {{ record.inspirator.name }}
                        </div>
                    </a-table-column>
                    <a-table-column-group>
                        <span slot="title">Evaluasi Pelaksanaan</span>
                        <a-table-column :width="200" key="ev_inspirator" title="Inspirator" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.score_inspirator }}</strong>
                            </template>
                        </a-table-column>
                        <a-table-column :width="200" key="ev_material" title="Materi" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.score_material }}</strong>
                            </template>
                        </a-table-column>
                        <a-table-column :width="200" key="ev_program" title="Program" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.score_program }}</strong>
                            </template>
                        </a-table-column>
                        <a-table-column :width="200" key="ev_event" title="Penyelenggaraan" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.score_event }}</strong>
                            </template>
                        </a-table-column>
                        <a-table-column :width="200" key="ev_accommodation" title="Akomodasi" className="align-center text-center">
                            <template slot-scope="record" v-if="! record.is_heading">
                                <strong> {{ record.score_accommodation }}</strong>
                            </template>
                        </a-table-column>
                    </a-table-column-group>

                    <a-table-column :width="200" key="result" title="Hasil" className="align-center text-center">
                        <template slot-scope="record" v-if="! record.is_heading">
                            <strong> {{ record.total }}</strong>
                        </template>
                    </a-table-column>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>
<script>
const TABLE_ROW = {
    is_heading: false,
    name: null,
    inspirator: null,
    score_inspirator: 0,
    score_material: 0,
    score_program: 0,
    score_event: 0,
    score_accommodation: 0,
    total: 0,
}
export default {
    created() {
        this.getItems()
    },
    computed: {
        excel() {
            let data = []
            let vm = this
            let category = null
            if (this.loading)
                return data

            this.tableData.forEach(function (item) {
                if (item.is_heading) {
                    category = item.name
                } else {
                    data.push({
                        category: category,
                        material: item.name,
                        inspirator: item.inspirator.name,
                        score_inspirator: item.score_inspirator,
                        score_material: item.score_material,
                        score_program: item.score_program,
                        score_event: item.score_event,
                        score_accommodation: item.score_accommodation,
                        result: item.total
                    })
                }
            })

            return data
        },
        tableData() {
            let data = []
            let num = 1

            if (this.items !== null) {
                this.items.forEach(function (item) {
                    data.push(Object.assign(Object.create(TABLE_ROW), {
                        id: num++,
                        is_heading: true,
                        name: item.category,
                    }))

                    item.materials.forEach(function(material) {
                        let sc_inspirator = material.scores['inspirator'].score ? parseFloat(material.scores['inspirator'].score).toFixed(2) : 0
                        let sc_material = material.scores['material'].score ? parseFloat(material.scores['material'].score).toFixed(2) : 0
                        let sc_program = material.scores['program'].score ? parseFloat(material.scores['program'].score).toFixed(2) : 0
                        let sc_event = material.scores['event'].score ? parseFloat(material.scores['event'].score).toFixed(2) : 0
                        let sc_accommodation = material.scores['acomodation'].score ? parseFloat(material.scores['acomodation'].score).toFixed(2) : 0
                        let sc_total = (parseFloat(sc_inspirator) + parseFloat(sc_material) + parseFloat(sc_program) + parseFloat(sc_event) + parseFloat(sc_accommodation)) / 5

                        data.push(Object.assign(Object.create(TABLE_ROW), {
                            id: num++,
                            name: material.name,
                            inspirator: material.inspirator,
                            score_inspirator: sc_inspirator,
                            score_material: sc_material,
                            score_program: sc_program,
                            score_event: sc_event,
                            score_accommodation: sc_accommodation,
                            total: sc_total.toFixed(2)
                        }))
                    })
                })
            }

            return data
        }
    },
    data() {
        return {
            loading: false,
            items: null
        }
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.training.evaluation.summary'))
                .then((r) => this.items = r.data)
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.loading = false)
        }
    }
}
</script>
